import { CourseFeatures } from './CourseFeatures.model';
import { CourseCategoryMaster } from './CourseCategoryMaster.model';
import { ContentMaster } from './ContentMaster.model';
import { TrainerMaster } from './TrainerMaster.model';
import { LectureMaster } from './LectureMaster.model';
import { CourseFeesMaster } from './CourseFeesMaster.model';
import { ReviewMaster } from './ReviewMaster.model';
import { DocumentMaster } from './DocumentMaster.model';
import { PredefinedMaster } from './PredefinedMaster.model';
import { FilterMasterModel } from './FilterMasterModel';

export class CourseMaster{
    public courseMasterId:number;
    public courseName:String;
    public courseTagLine:String;
    public courseDescription:String;
    public actualPrice:number;
    public offeredPrice:number;
   public  courseCategoriesList:CourseCategoryMaster;
    public ageGroup:String;
    public courseFeaturesList:CourseFeatures[];
    public courseBanner:ContentMaster;
    public courseContentMasterList:ContentMaster[];
    public trainerMaster:TrainerMaster;
    public lectureMasterList:LectureMaster[];
    public isDeactive:string;
    public isDelete:string;
    public courseFeesList:CourseFeesMaster[];
    public reviewMasterList:ReviewMaster[];
    public isInvisible:boolean = false;
    public pageNumber:number;
    public pageSize:number;
    public isMasterCourse:boolean;
    public searchValue:string;
    public courseBrochure:DocumentMaster;
    public courseBannerVideo:DocumentMaster;
    public courseLanguageMasterList:CourseCategoryMaster[]=[];
    public courseLanguagePredefinedMasterListTemp:PredefinedMaster[]=[];
    public courseLectureMasterList:any[]=[];
    public languageTemp:PredefinedMaster;
    public sortOrder:PredefinedMaster;
    public filtersListTemp:FilterMasterModel[]=[];
    
    public studentMasterId:number;
    public errorMessage:string;
    public enrollCourseMasterId:number;
        
}